import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ac0d50"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "m-0 p-0 vp-panel-name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right vp-font-small" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "m-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_panel = _resolveComponent("panel")!

  return (_openBlock(), _createBlock(_component_panel, { class: "vp-panel w-full text-center font-bold" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: tab.key
        }, [
          (!tab.hide)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                class: _normalizeClass({
          'justify-content-between': tab.route,
          'vp-tab align-items-center': true,
          flex: true,
        })
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass({
            'pr-4': !tab.route,
          }),
                  src: tab.icon
                }, null, 10, _hoisted_1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(tab.name), 1),
                (tab.route)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "no-underline",
                      to: tab.route
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("overview.link")) + " ", 1),
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.isLastTab(i))
            ? (_openBlock(), _createElementBlock("hr", _hoisted_4))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}